import type { CutdownCardBlockData } from '@/components/canvas/blocks/types';
import type { CutdownCardProps } from '@/components/CutdownCard';

export function cutdownCardPropsFromBlockData(
  data: CutdownCardBlockData,
): Pick<
  CutdownCardProps,
  | 'date'
  | 'layout'
  | 'units'
  | 'backgroundColor'
  | 'border'
  | 'numberColor'
  | 'labelColor'
  | 'borderRadius'
  | 'cardSize'
  | 'gap'
  | 'scale'
  | 'animate'
> {
  const stroke = data.stroke;
  const border = stroke
    ? `${stroke.width}px ${stroke.style ?? 'solid'} ${stroke.color}`
    : undefined;

  return {
    ...(data.date ? { date: data.date } : {}),
    layout: data.layout,
    units: data.units,
    backgroundColor: data.backgroundColor,
    border,
    numberColor: data.numberColor,
    labelColor: data.labelColor,
    borderRadius: data.borderRadius,
    cardSize: data.cardSize,
    gap: data.gap,
    scale: data.scale,
    animate: data.animate,
  };
}
